import { render, staticRenderFns } from "./CadastroTemplateEmail.vue?vue&type=template&id=2ffcbb42"
import script from "./CadastroTemplateEmail.vue?vue&type=script&lang=js"
export * from "./CadastroTemplateEmail.vue?vue&type=script&lang=js"
import style0 from "./CadastroTemplateEmail.vue?vue&type=style&index=0&id=2ffcbb42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports